/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export class MouseOperations {
    public static readonly MOUSE_CLICK: string = 'click';

    public static readonly MOUSE_CONTEXT_MENU: string = 'contextmenu';

    public static readonly MOUSE_DOWN: string = 'mousedown';

    public static readonly MOUSE_ENTER: string = 'mouseenter';

    public static readonly MOUSE_LEAVE: string = 'mouseleave';

    public static readonly MOUSE_MOVE: string = 'mousemove';

    public static readonly MOUSE_OUT: string = 'mouseout';

    public static readonly MOUSE_OVER: string = 'mouseover';

    public static readonly MOUSE_UP: string = 'mouseup';

    public static readonly MOUSE_WHEEL: string = 'wheel';
}
